<template>
  <dashboard-layout>
    <div class="pricing-page">
      <div class="current">
        <img src="@/assert/clean_renamed/人物立绘-首页女主.png" alt="" class="user-av" />
        <div class="info">
          <h2>
            当前套餐：{{ sub ? sub.plan_name : "—" }}
            <span class="tag">{{ sub && sub.status === "expired" ? "已到期" : "使用中" }}</span>
          </h2>
          <p>到期时间：{{ sub ? formatExpiry(sub.expires_at) : "—" }} <a @click="scrollToPlans">续费 / 升级套餐 ></a></p>
          <div class="stats" v-if="sub">
            <span>消息 {{ sub.message_used }}/{{ sub.message_limit }}</span>
            <span>生图 {{ sub.image_used }}/{{ sub.image_limit }}</span>
            <span>语音 {{ sub.voice_used }}/{{ sub.voice_limit }}</span>
          </div>
        </div>
        <div class="welcome">
          <p>{{ userName }}，你好呀 👋</p>
          <small>感谢你一直以来的陪伴，xyo.chat 会越来越好~</small>
          <img src="@/assert/clean_renamed/双爱心-渐变.png" alt="" class="welcome-heart" />
        </div>
      </div>

      <div class="plan-head">
        <div>
          <h2>选择适合你的套餐</h2>
          <p>不同套餐满足不同陪伴需求，随时可升级</p>
        </div>
        <div v-if="yearlyPaymentEnabled" class="toggle">
          <span :class="{ on: !yearly }">按月付费</span>
          <el-switch v-model="yearly" active-color="#c94225" />
          <span :class="{ on: yearly }">按年付费</span>
          <em class="badge">年付立省 20%</em>
        </div>
      </div>

      <div class="plans">
        <div v-for="p in list" :key="p.id" class="plan" :class="{ hot: p.highlight }">
          <span v-if="p.tag" class="rec">{{ p.tag }}</span>
          <h3>{{ p.title }}</h3>
          <div class="price"><small>¥</small>{{ p.price }}<em>{{ p.unit }}</em></div>
          <ul>
            <li v-for="b in p.benefits" :key="b"><i class="el-icon-check"></i>{{ b }}</li>
          </ul>
          <el-button
            :type="p.highlight ? 'primary' : 'default'"
            round
            class="buy"
            :disabled="p.disabled"
            @click="openBuy(p)"
          >
            {{ p.actionText }}
          </el-button>
          <img v-if="p.highlight" src="@/assert/clean_renamed/爱心主图-渐变立体.png" alt="" class="plan-heart" />
        </div>
      </div>

      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>权益对比</th>
              <th
                v-for="plan in comparisonPlans"
                :key="plan.code"
                :class="{ 'hot-col': plan.is_recommended }"
              >
                {{ plan.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in compareRows" :key="r.name">
              <td>{{ r.name }}</td>
              <td
                v-for="plan in comparisonPlans"
                :key="plan.code"
                :class="{ 'hot-col': plan.is_recommended }"
              >
                {{ comparisonValue(r, plan) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 购买 / 升级确认 -->
    <el-dialog title="确认订单" :visible.sync="buyVisible" width="420px" custom-class="yw-dialog">
      <div class="order" v-if="buyPlan">
        <div class="o-row"><span>套餐</span><b>{{ buyPlan.title }}</b></div>
        <div class="o-row"><span>计费方式</span><b>{{ yearly ? "按年付费（立省 20%）" : "按月付费" }}</b></div>
        <div class="o-row"><span>当前套餐</span><b>{{ sub ? sub.plan_name : "暂无" }}（升档将立即生效）</b></div>
        <div class="o-row total">
          <span>应付金额</span>
          <b class="amount">¥{{ payAmount }}<em>{{ yearly ? "/年" : "/月" }}</em></b>
        </div>
        <div class="pay-methods">
          <label>支付方式</label>
          <div class="methods">
            <button type="button" :class="{ on: paymentChannel === 'alipay' }" @click="paymentChannel = 'alipay'">
              <i class="el-icon-wallet"></i> 支付宝
            </button>
            <button type="button" :class="{ on: paymentChannel === 'wechat' }" @click="paymentChannel = 'wechat'">
              <i class="el-icon-chat-round"></i> 微信支付
            </button>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button round @click="buyVisible = false">取消</el-button>
        <el-button type="primary" round :loading="creating" @click="confirmBuy">去支付</el-button>
      </span>
    </el-dialog>

    <!-- 扫码支付 -->
    <el-dialog
      :title="paymentDialogTitle"
      :visible.sync="qrVisible"
      width="380px"
      custom-class="yw-dialog"
      :close-on-click-modal="!cancelSubmitting"
      :close-on-press-escape="!cancelSubmitting"
      :show-close="!cancelSubmitting"
      @close="stopPolling"
    >
      <div class="qr-pay" v-if="order">
        <p class="qr-amount">¥{{ order.amount }} <em>{{ order.plan_name }}（{{ order.period === "yearly" ? "年付" : "月付" }}）</em></p>
        <img v-if="order.qr_image" :src="order.qr_image" :alt="`${paymentLabel}二维码`" class="qr-img" />
        <div v-if="isMobilePaymentDevice() && paymentTarget() && payState === 'pending' && order.qr_image" class="mobile-pay-action">
          <el-button size="small" round type="primary" @click="openCashier">在当前设备打开{{ paymentLabel }}</el-button>
        </div>
        <div v-else-if="order.pay_url && payState === 'pending'" class="cashier-tip">
          <p>已在新窗口打开{{ paymentLabel }}收银台</p>
          <el-button size="small" round type="primary" @click="openCashier">没打开？点这里重新打开</el-button>
        </div>
        <p class="qr-tip" v-if="payState === 'pending'"><i class="el-icon-loading"></i> {{ paymentPendingTip }}</p>
        <p class="qr-tip ok" v-else-if="payState === 'paid'"><i class="el-icon-success"></i> 支付成功，套餐已开通！</p>
        <p class="qr-tip processing" v-else-if="payState === 'cancelling'"><i class="el-icon-loading"></i> 正在向支付渠道确认取消，请稍候</p>
        <p class="qr-tip cancelled" v-else-if="payState === 'cancelled'"><i class="el-icon-circle-check"></i> {{ cancelledMessage }}</p>
        <p class="qr-tip err" v-else-if="payState === 'closed'"><i class="el-icon-warning"></i> 订单已关闭，请重新下单</p>
      </div>
      <span slot="footer" class="payment-footer">
        <template v-if="payState === 'pending'">
          <el-button round :disabled="cancelSubmitting" @click="payLater">稍后支付</el-button>
          <el-button type="danger" round :loading="cancelSubmitting" @click="cancelCurrentOrder">取消订单</el-button>
        </template>
        <el-button v-else round @click="qrVisible = false">{{ payState === "paid" ? "完成" : "关闭" }}</el-button>
      </span>
    </el-dialog>
  </dashboard-layout>
</template>

<script>
import { dashboardApi, paymentApi, getUser } from "@/services/api";
import DashboardLayout from "@/components/DashboardLayout.vue";

export default {
  name: "PricingView",
  components: { DashboardLayout },
  data() {
    const u = getUser();
    return {
      yearlyPaymentEnabled: false,
      yearly: false,
      paymentChannel: "alipay",
      buyVisible: false,
      buyPlan: null,
      creating: false,
      qrVisible: false,
      order: null,
      payState: "pending",
      pollTimer: null,
      pollRequestActive: false,
      cancelSubmitting: false,
      list: [],
      comparisonPlans: [],
      sub: null,
      userName: (u && u.display_name) || "你好",
      compareRows: [
        { name: "消息额度", key: "message_limit", unit: "条/月" },
        { name: "图片生成", key: "image_limit", unit: "张/月" },
        { name: "语音消息", key: "voice_limit", unit: "条/月" },
        { name: "伴侣数量", key: "companion_limit", unit: "个" },
        { name: "角色卡数量", key: "role_card_limit", unit: "个" },
        { name: "微信接管", key: "wechat_takeover_days", unit: "天" },
        { name: "角色卡私享", key: "allow_role_sharing", type: "boolean" },
      ],
    };
  },
  computed: {
    payAmount() {
      if (!this.buyPlan) return 0;
      const monthly = Number(this.buyPlan.price);
      return this.yearly ? Math.round(monthly * 12 * 0.8) : monthly;
    },
    paymentLabel() {
      const channel = (this.order && this.order.channel) || this.paymentChannel;
      return channel === "wechat" ? "微信支付" : "支付宝";
    },
    paymentDialogTitle() {
      const isCashierPayment = this.order && this.order.pay_url && !this.order.qr_image;
      return `${this.paymentLabel}${isCashierPayment ? "" : "扫码"}支付`;
    },
    paymentPendingTip() {
      if (!this.order) return "正在创建支付订单";
      if (this.order.qr_image) return `请使用${this.paymentLabel}扫码，支付完成后自动开通`;
      return "完成支付后这里会自动确认开通";
    },
    cancelledMessage() {
      const closeStatus = (this.order && this.order.channel_close_status) || "";
      if (closeStatus === "confirmed") return "订单已取消，支付渠道已关闭";
      if (closeStatus === "unsupported") return "本地已取消，请勿继续使用原支付页面；若渠道确认付款仍会自动开通";
      return "订单已取消；若渠道确认付款，系统仍会自动开通套餐";
    },
  },
  created() {
    this.load();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    formatExpiry(value) {
      if (!value || !String(value).includes("T")) return value || "—";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString("zh-CN", { hour12: false });
    },
    async load() {
      try {
        const dash = await dashboardApi.get();
        this.userName = dash.user.display_name;
        this.sub = dash.subscription;
        const curCode = dash.subscription ? dash.subscription.plan_code : "";
        const plans = dash.available_plans || [];
        const comparisonCodes = new Set(["trial", "basic", "standard", "pro"]);
        this.comparisonPlans = plans
          .filter((p) => comparisonCodes.has(p.code))
          .sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0));
        const currentPlan = plans.find((p) => p.code === curCode);
        const currentRank = currentPlan ? [Number(currentPlan.sort_order) || 0, Number(currentPlan.monthly_price) || 0] : null;
        this.list = plans.map((p) => {
          const isFreeTrial = p.code === "free_trial";
          const planRank = [Number(p.sort_order) || 0, Number(p.monthly_price) || 0];
          const isCurrent = p.code === curCode;
          const isDowngrade = currentRank
            ? planRank[0] < currentRank[0] || (planRank[0] === currentRank[0] && planRank[1] < currentRank[1])
            : false;
          return {
            id: p.code,
            title: p.name,
            price: String(p.monthly_price),
            unit: isFreeTrial ? "/3天" : "/月",
            highlight: isCurrent,
            disabled: isCurrent || isDowngrade,
            actionText: isCurrent ? "当前套餐" : isDowngrade ? "不可降档" : currentRank ? "立即升级" : "立即开通",
            tag: p.is_recommended ? "推荐" : "",
            benefits: [
              `消息 ${p.message_limit} 条${isFreeTrial ? "/试用期" : "/月"}`,
              `生图 ${p.image_limit} 张${isFreeTrial ? "/试用期" : "/月"}`,
              `语音 ${p.voice_limit} 条${isFreeTrial ? "/试用期" : "/月"}`,
            ],
          };
        });
      } catch (e) {
        this.$message.warning("加载套餐失败");
      }
    },
    openBuy(p) {
      if (p.disabled) return;
      if (!this.yearlyPaymentEnabled) this.yearly = false;
      this.buyPlan = p;
      this.buyVisible = true;
    },
    comparisonValue(row, plan) {
      if (row.type === "boolean") return plan[row.key] ? "✓" : "—";
      const value = Number(plan[row.key]) || 0;
      return value > 0 ? `${value} ${row.unit}` : "不限";
    },
    async confirmBuy() {
      if (!this.buyPlan) return;
      this.creating = true;
      try {
        const mobilePaymentDevice = this.isMobilePaymentDevice();
        const paymentMode = this.paymentChannel === "alipay" && mobilePaymentDevice ? "wap" : "qr";
        const order = await paymentApi.precreate(
          this.buyPlan.id,
          this.yearlyPaymentEnabled && this.yearly ? "yearly" : "monthly",
          this.paymentChannel,
          paymentMode
        );
        this.order = order;
        this.payState = "pending";
        this.buyVisible = false;
        this.qrVisible = true;
        const paymentTarget = this.paymentTarget(order);
        if (mobilePaymentDevice && paymentTarget) {
          window.location.assign(paymentTarget);
          return;
        }
        if (!order.qr_image && order.pay_url) this.openCashier();
        this.startPolling();
      } catch (e) {
        this.$message.error(e.message || "下单失败，请稍后再试");
      } finally {
        this.creating = false;
      }
    },
    startPolling() {
      this.stopPolling();
      this.pollTimer = setInterval(async () => {
        if (!this.order || this.pollRequestActive) return;
        const outTradeNo = this.order.out_trade_no;
        this.pollRequestActive = true;
        try {
          const latest = await paymentApi.orderStatus(outTradeNo);
          if (!this.order || this.order.out_trade_no !== outTradeNo) return;
          if (this.cancelSubmitting) return;
          this.order = { ...this.order, ...latest };
          if (latest.status === "paid") {
            this.payState = "paid";
            this.stopPolling();
            this.$message.success(`「${latest.plan_name}」已开通`);
            this.load();
          } else if (latest.status === "cancelling") {
            this.payState = "cancelling";
          } else if (latest.status === "cancelled") {
            this.payState = "cancelled";
            this.stopPolling();
          } else if (latest.status === "closed") {
            this.payState = "closed";
            this.stopPolling();
          } else {
            this.payState = "pending";
          }
        } catch (e) {
          /* 网络抖动忽略，下次轮询重试 */
        } finally {
          this.pollRequestActive = false;
        }
      }, 3000);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    payLater() {
      this.qrVisible = false;
      this.$message.info("订单仍保留为待支付，可在个人中心查看");
    },
    async cancelCurrentOrder() {
      if (!this.order || this.payState !== "pending" || this.cancelSubmitting) return;
      const confirmed = await this.$confirm(
        "系统将停止展示当前二维码和支付链接，并尽力向支付渠道关闭订单；若支付已经完成，仍以渠道结果为准。",
        "确认取消订单",
        {
          type: "warning",
          confirmButtonText: "确认取消",
          cancelButtonText: "继续支付",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirmed) return;
      if (this.payState !== "pending") return;

      this.cancelSubmitting = true;
      this.stopPolling();
      try {
        const latest = await paymentApi.cancelOrder(this.order.out_trade_no);
        this.order = { ...this.order, ...latest };
        this.payState = latest.status || "cancelling";
        if (this.payState === "paid") {
          this.stopPolling();
          this.$message.success(`「${latest.plan_name}」已开通`);
          this.load();
        } else if (this.payState === "cancelled") {
          this.stopPolling();
          this.$message.success("取消结果已更新，请勿继续使用原支付页面");
        } else if (this.payState === "closed") {
          this.stopPolling();
          this.$message.info("订单已由支付渠道关闭");
        } else {
          this.payState = "cancelling";
          this.startPolling();
          this.$message.info("取消申请已提交，正在等待支付渠道确认");
        }
      } catch (e) {
        this.$message.error(e.message || "取消订单失败，请稍后重试");
        if (this.payState === "pending" || this.payState === "cancelling") this.startPolling();
      } finally {
        this.cancelSubmitting = false;
      }
    },
    openCashier() {
      const paymentTarget = this.paymentTarget();
      if (!paymentTarget) return;
      if (this.isMobilePaymentDevice()) {
        window.location.assign(paymentTarget);
        return;
      }
      window.open(paymentTarget, "_blank");
    },
    paymentTarget(order = this.order) {
      if (!order) return "";
      if (order.pay_url) return order.pay_url;
      return order.channel === "alipay" ? order.qr_code || "" : "";
    },
    isMobilePaymentDevice() {
      const userAgent = (window.navigator && window.navigator.userAgent) || "";
      const mobileUserAgent = /Android|iPhone|iPad|iPod|Mobile|HarmonyOS/i.test(userAgent);
      const isIPadDesktopMode =
        window.navigator && window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1;
      const coarsePointer = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
      return mobileUserAgent || isIPadDesktopMode || !!coarsePointer;
    },
    scrollToPlans() {
      const el = this.$el.querySelector(".plans");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style scoped lang="scss">
.pricing-page {
  .current {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 24px;
    padding: 24px 28px;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);

    .user-av {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      border: 3px solid var(--xyo-line-strong);
      object-fit: cover;
      object-position: center 18%;
      background: var(--xyo-accent-pale);
    }

    .info {
      flex: 1;

      h2 {
        margin: 0 0 8px;
        font-size: 20px;

        .tag {
          padding: 2px 10px;
          border-radius: 10px;
          color: var(--xyo-primary);
          font-size: 12px;
          font-weight: 400;
          background: var(--xyo-accent-pale);
        }
      }

      p {
        margin: 0 0 12px;
        color: #999;
        font-size: 13px;

        a {
          margin-left: 8px;
          color: var(--xyo-primary);
          text-decoration: none;
        }
      }

      .stats {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        span {
          color: #666;
          font-size: 12px;
        }
      }
    }

    .welcome {
      position: relative;
      text-align: right;

      p {
        margin: 0 0 4px;
        font-size: 16px;
        font-weight: 600;
      }

      small {
        color: #999;
        font-size: 12px;
      }

      .welcome-heart {
        position: absolute;
        right: -6px;
        top: -14px;
        width: 44px;
      }
    }
  }

  .plan-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;

    h2 {
      margin: 0 0 6px;
      font-size: 22px;
    }

    > div > p {
      margin: 0;
      color: #999;
      font-size: 13px;
    }

    .toggle {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: #999;

      .on {
        color: #333;
        font-weight: 600;
      }

      .badge {
        padding: 2px 8px;
        border-radius: 8px;
        color: #fff;
        font-size: 11px;
        font-style: normal;
        background: var(--xyo-warning);
      }
    }
  }

  .plans {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    margin-bottom: 24px;

    .plan {
      position: relative;
      padding: 28px 24px;
      border-radius: 20px;
      text-align: center;
      background: #fff;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
      transition: transform 0.25s, box-shadow 0.25s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: var(--xyo-shadow-sm);
      }

      &.hot {
        border: 2px solid var(--xyo-primary);
        background: var(--xyo-accent-pale);
      }

      .rec {
        position: absolute;
        top: 16px;
        right: 16px;
        padding: 2px 10px;
        border-radius: 10px;
        color: #fff;
        font-size: 11px;
        background: var(--xyo-primary);
      }

      h3 {
        margin: 0 0 12px;
        font-size: 18px;
      }

      .price {
        margin-bottom: 20px;
        color: var(--xyo-primary);
        font-size: 42px;
        font-weight: 700;

        small {
          font-size: 18px;
        }

        em {
          font-size: 14px;
          font-style: normal;
          color: #999;
        }
      }

      ul {
        margin: 0 0 20px;
        padding: 0;
        list-style: none;
        text-align: left;

        li {
          margin-bottom: 10px;
          color: #666;
          font-size: 13px;

          i {
            margin-right: 6px;
            color: var(--xyo-success);
          }
        }
      }

      .buy {
        width: 100%;
      }

      &.hot .buy {
        border: 0;
        background: var(--xyo-primary);
      }

      .plan-heart {
        position: absolute;
        right: 8px;
        bottom: 10px;
        width: 34px;
      }
    }
  }

  .table-wrap {
    padding: 20px 24px;
    border-radius: 20px;
    background: #fff;

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 13px;

      th,
      td {
        padding: 14px 12px;
        text-align: center;
        border-bottom: 1px solid var(--xyo-line);
      }

      th {
        color: #999;
        font-weight: 500;
      }

      td:first-child {
        text-align: left;
        color: #666;
      }

      .hot-col {
        color: var(--xyo-primary);
        font-weight: 500;
        background: var(--xyo-accent-pale);
      }
    }
  }

  @media (max-width: 768px) {
    .current {
      flex-wrap: wrap;
      gap: 12px;
      padding: 16px;
    }

    .plans {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .table-wrap {
      padding: 12px;
      overflow-x: auto;

      table {
        min-width: 480px;
      }
    }
  }
}

.order {
  .o-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid var(--xyo-line);
    font-size: 14px;

    span {
      color: #999;
    }

    &.total {
      border-bottom: 0;

      .amount {
        color: var(--xyo-primary);
        font-size: 26px;
        font-weight: 700;

        em {
          font-size: 13px;
          font-style: normal;
          color: #999;
        }
      }
    }
  }

  .pay-methods {
    margin-top: 8px;

    label {
      display: block;
      margin-bottom: 8px;
      color: #999;
      font-size: 13px;
    }

    .methods {
      display: flex;
      gap: 12px;

      button {
        flex: 1;
        padding: 12px;
        border: 1px solid var(--xyo-line);
        border-radius: 12px;
        color: inherit;
        background: transparent;
        font: inherit;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        transition: 0.2s;

        i {
          margin-right: 4px;
        }

        &.on {
          border-color: var(--xyo-primary);
          color: var(--xyo-primary);
          background: var(--xyo-accent-pale);
        }

      }
    }
  }

  .qr-pay {
    text-align: center;

    .qr-amount {
      margin: 0 0 12px;
      color: var(--xyo-primary);
      font-size: 24px;
      font-weight: 700;

      em {
        color: #999;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
      }
    }

    .qr-img {
      width: 220px;
      height: 220px;
      border: 1px solid var(--xyo-line);
      border-radius: 12px;
    }

    .cashier-tip {
      padding: 24px 0 8px;

      p {
        margin: 0 0 12px;
        color: #666;
        font-size: 14px;
      }
    }

    .mobile-pay-action {
      margin-top: 12px;
    }

    .qr-tip {
      margin: 12px 0 0;
      color: #999;
      font-size: 13px;

      &.ok {
        color: #52c41a;
      }

      &.processing {
        color: #409eff;
      }

      &.cancelled {
        color: #666;
      }

      &.err {
        color: #f5222d;
      }
    }
  }

  .note {
    margin: 16px 0 0;
    color: #faad14;
    font-size: 12px;

    i {
      margin-right: 4px;
    }
  }
}
</style>

<style scoped lang="scss">
/* Warm, restrained pricing workspace: usage, decision, comparison. */
.pricing-page {
  width: 100%;
  max-width: 1280px;
  min-width: 0;
  margin: 0 auto;
  color: var(--xyo-ink);

  .current {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 28px;
    margin-bottom: 36px;
    padding: 26px 28px;
    border: 1px solid var(--xyo-line);
    border-radius: var(--xyo-radius-lg);
    background: var(--xyo-surface-raised);
    box-shadow: var(--xyo-shadow-sm);

    .user-av,
    .welcome-heart {
      display: none;
    }

    .info {
      min-width: 0;

      h2 {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 9px;
        margin: 0 0 8px;
        color: var(--xyo-ink-strong);
        font-size: clamp(22px, 2vw, 28px);
        font-weight: 720;
        letter-spacing: -0.02em;

        .tag {
          padding: 4px 9px;
          border: 1px solid #c9dbcf;
          border-radius: 999px;
          color: var(--xyo-success);
          background: var(--xyo-success-soft);
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0;
        }
      }

      p {
        margin: 0 0 18px;
        color: var(--xyo-muted);
        font-size: 13px;
        line-height: 1.6;

        a {
          display: inline-block;
          margin-left: 8px;
          color: var(--xyo-primary);
          font-weight: 700;
          text-decoration: none;
        }
      }

      .stats {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 8px;

        span {
          min-width: 0;
          padding: 10px 12px;
          border-left: 2px solid #e6a37e;
          border-radius: var(--xyo-radius-sm);
          color: var(--xyo-ink-soft);
          background: var(--xyo-surface-muted);
          font-size: 12px;
          font-variant-numeric: tabular-nums;
          line-height: 1.45;
          overflow-wrap: anywhere;
        }
      }
    }

    .welcome {
      max-width: 260px;
      padding-left: 28px;
      border-left: 1px solid var(--xyo-line);
      text-align: left;

      p {
        margin: 0 0 6px;
        color: var(--xyo-ink);
        font-size: 14px;
        font-weight: 700;
      }

      small {
        color: var(--xyo-muted);
        font-size: 12px;
        line-height: 1.65;
      }
    }
  }

  .plan-head {
    align-items: center;
    gap: 24px;
    margin-bottom: 14px;

    h2 {
      margin-bottom: 5px;
      color: var(--xyo-ink-strong);
      font-size: 21px;
      font-weight: 720;
    }

    > div > p {
      color: var(--xyo-muted);
      line-height: 1.6;
    }

    .toggle {
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 9px;
      padding: 7px 9px 7px 12px;
      border: 1px solid var(--xyo-line);
      border-radius: 999px;
      color: var(--xyo-muted);
      background: var(--xyo-surface-raised);

      .on {
        color: var(--xyo-ink-strong);
      }

      .badge {
        padding: 4px 8px;
        border-radius: 999px;
        color: #fff;
        background: var(--xyo-warning);
        font-size: 10px;
        font-weight: 700;
      }
    }
  }

  .plans {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px;
    margin-bottom: 36px;

    .plan {
      display: flex;
      min-width: 0;
      min-height: 360px;
      flex-direction: column;
      padding: 25px 22px 22px;
      border: 1px solid var(--xyo-line);
      border-radius: var(--xyo-radius-md);
      text-align: left;
      background: var(--xyo-surface-raised);
      box-shadow: none;
      transition: border-color 180ms ease, background-color 180ms ease, box-shadow 180ms ease;

      &:hover {
        border-color: var(--xyo-line-strong);
        background: var(--xyo-accent-pale);
        box-shadow: var(--xyo-shadow-sm);
        transform: none;
      }

      &.hot {
        border: 2px solid var(--xyo-primary);
        background: var(--xyo-accent-pale);
      }

      .rec {
        top: 14px;
        right: 14px;
        padding: 4px 9px;
        border-radius: 999px;
        color: #fff;
        background: var(--xyo-primary);
        font-size: 10px;
        font-weight: 750;
      }

      h3 {
        margin: 0 0 8px;
        padding-right: 62px;
        color: var(--xyo-ink-strong);
        font-size: 17px;
        font-weight: 720;
      }

      .price {
        margin-bottom: 20px;
        color: var(--xyo-ink-strong);
        font-size: 38px;
        font-weight: 750;
        font-variant-numeric: tabular-nums;
        letter-spacing: -0.035em;

        small {
          margin-right: 2px;
          color: var(--xyo-primary);
          font-size: 16px;
        }

        em {
          margin-left: 4px;
          color: var(--xyo-muted);
          font-size: 12px;
          letter-spacing: 0;
        }
      }

      ul {
        flex: 1;
        margin-bottom: 22px;

        li {
          display: flex;
          align-items: flex-start;
          margin-bottom: 11px;
          color: var(--xyo-ink-soft);
          font-size: 13px;
          line-height: 1.55;

          i {
            margin: 3px 7px 0 0;
            color: var(--xyo-success);
            font-weight: 700;
          }
        }
      }

      .buy {
        width: 100%;
        min-height: 42px;
      }

      &.hot .buy {
        border-color: var(--xyo-primary);
        color: #fff;
        background: var(--xyo-primary);
      }

      .plan-heart {
        display: none;
      }
    }
  }

  .table-wrap {
    overflow: hidden;
    padding: 0;
    border: 1px solid var(--xyo-line);
    border-radius: var(--xyo-radius-lg);
    background: var(--xyo-surface-raised);
    box-shadow: var(--xyo-shadow-sm);

    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      color: var(--xyo-ink-soft);
      font-size: 13px;

      th,
      td {
        padding: 15px 12px;
        border-bottom: 1px solid var(--xyo-line);
        line-height: 1.45;
        overflow-wrap: anywhere;
      }

      tr:last-child td {
        border-bottom: 0;
      }

      th {
        color: var(--xyo-ink);
        background: var(--xyo-surface-muted);
        font-size: 12px;
        font-weight: 720;
      }

      th:first-child,
      td:first-child {
        width: 31%;
        padding-left: 22px;
        color: var(--xyo-ink);
        text-align: left;
      }

      .hot-col {
        color: var(--xyo-primary);
        background: var(--xyo-accent-pale);
        font-weight: 700;
      }
    }
  }

  ::v-deep .el-switch.is-checked .el-switch__core {
    border-color: var(--xyo-primary) !important;
    background: var(--xyo-primary) !important;
  }
}

.order {
  color: var(--xyo-ink);

  .o-row {
    gap: 20px;
    border-bottom-color: var(--xyo-line);

    span {
      flex: 0 0 auto;
      color: var(--xyo-muted);
    }

    b {
      min-width: 0;
      color: var(--xyo-ink-strong);
      text-align: right;
      overflow-wrap: anywhere;
    }

    &.total .amount {
      color: var(--xyo-primary);
      font-variant-numeric: tabular-nums;

      em {
        color: var(--xyo-muted);
      }
    }
  }

  .pay-methods {
    label {
      color: var(--xyo-muted);
    }

    .methods {
      button {
        border-color: var(--xyo-line);
        color: var(--xyo-ink-soft);
        background: var(--xyo-surface-raised);

        &.on {
          border-color: var(--xyo-primary);
          color: var(--xyo-primary);
          background: var(--xyo-accent-pale);
        }

      }
    }
  }
}

.qr-pay {
  .qr-amount {
    color: var(--xyo-primary);
    font-variant-numeric: tabular-nums;

    em {
      color: var(--xyo-muted);
    }
  }

  .qr-img {
    max-width: 100%;
    border-color: var(--xyo-line);
  }

  .cashier-tip p,
  .qr-tip {
    color: var(--xyo-muted);
  }

  .qr-tip.ok {
    color: var(--xyo-success);
  }

  .qr-tip.processing {
    color: var(--xyo-info);
  }

  .qr-tip.cancelled {
    color: var(--xyo-ink-soft);
  }

  .qr-tip.err {
    color: var(--xyo-danger);
  }
}

.payment-footer {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;

  ::v-deep .el-button + .el-button {
    margin-left: 0;
  }
}

@media (max-width: 900px) {
  .pricing-page {
    .current {
      grid-template-columns: minmax(0, 1fr);

      .welcome {
        max-width: none;
        padding: 18px 0 0;
        border-top: 1px solid var(--xyo-line);
        border-left: 0;
      }
    }

    .plan-head {
      align-items: flex-start;
      flex-direction: column;

      .toggle {
        justify-content: flex-start;
      }
    }
  }
}

@media (max-width: 640px) {
  .pricing-page {
    overflow-x: hidden;

    .current {
      gap: 20px;
      margin-bottom: 30px;
      padding: 22px 18px;
      border-radius: var(--xyo-radius-md);

      .info {
        h2 {
          font-size: 22px;
        }

        p a {
          margin: 6px 0 0;
        }

        .stats {
          grid-template-columns: repeat(2, minmax(0, 1fr));

          span {
            padding: 9px 10px;
            font-size: 11px;
          }
        }
      }
    }

    .plan-head {
      gap: 14px;

      .toggle {
        width: 100%;
        border-radius: var(--xyo-radius-md);
      }
    }

    .plans {
      grid-template-columns: minmax(0, 1fr);
      margin-bottom: 30px;

      .plan {
        min-height: 0;
        padding: 22px 18px 18px;
      }
    }

    .table-wrap {
      overflow-x: auto;
      border-radius: var(--xyo-radius-md);

      table {
        min-width: 640px;
        font-size: 12px;

        th,
        td {
          padding: 11px 8px;
          word-break: break-word;
        }

        th:first-child,
        td:first-child {
          width: 29%;
          padding-left: 9px;
        }
      }
    }
  }

  .order .pay-methods .methods {
    flex-direction: column;
  }

  ::v-deep .yw-dialog {
    width: calc(100vw - 32px) !important;
    max-width: 420px;
    margin-top: 8vh !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pricing-page .plan {
    transition: none;
  }
}
</style>
